<script>
  import Spinner from "../../components/ihm/ToolsSpinner.svelte";
  import { urlServeur, pathFilesRecettes } from "../conf.js";
  import { blur } from "svelte/transition";

  let brutRows = [];

  /**
   *
   */
  const fetchData2 = async () => {
    const response = await fetch(
      urlServeur + "/api/permis/contenuDossierImage"
    );
    if (response.ok) {
      const result = await response.json();
      brutRows = result.payload;
      console.log(brutRows);
      return brutRows;
    }
  };

  /**
   *
   */
  const fetchData = async () => {
    const response = await fetch(
      urlServeur + "/api/permis/contenuDossierImage/recettes"
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error("unable to load liste images  ");
        }
        return response.json();
      })
      .then(function (data) {
        brutRows = data.payload;
        console.log(brutRows);
        return brutRows;
      });
  };

  const promise = fetchData();
</script>

<h4>Liste images recettes</h4>
{#await brutRows}
  <Spinner />
{:then data}
  <ul class="list-group">
    {#each data as item}
      <li class="list-group-item" in:blur>
        <div class="photo">
          <img
            src="{pathFilesRecettes}{item}"
            alt=""
            width="80%"
            height="80%"
          />
        </div>
      </li>
    {/each}
  </ul>
{/await}

<style>
  .photo {
    margin-bottom: 5px;
  }
</style>
